import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Script from 'next/script';
import { actions as uiActions } from '@/reducers/ui';
import Configurador from '@/components/Configurador';
import AutoSelection from '@/components/AutoSelection';
import Confirmation from '@/components/Confirmation';
import Tapon from '@/components/Tapon';
import ToolTip from '@/components/ToolTip';
import BouncingLogo from '@/components/BouncingLogo';



const FullConfig = () => {
  const dispatch = useDispatch();
  const autoSelection = useSelector((state) => state.UI.autoSelection);
  const confirmation = useSelector((state) => state.UI.confirmation);
  const bouncingLogo = useSelector((state) => state.UI.bouncingLogo);
  const tapon = useSelector((state) => state.UI.tapon);
  const main = useSelector((state) => state.main);
  const notification = useSelector((state) => state.UI.notification);

  useEffect(() => {
    const logged = main?.logged;
    if (logged !== 0) {
      const url = new URL(window.location.href);
      dispatch(uiActions.initializeConfig({ url }));
    }
  }, [main?.logged]);

  return (
    <>
      <Script
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID}`}
        strategy="lazyOnload"
        onReady={() => { dispatch(uiActions.setRecaptcha(true)); }}
      />
      {!tapon && bouncingLogo && <div className="bouncingLogo"><BouncingLogo /></div>}
      {!bouncingLogo && !tapon && !confirmation && (<Configurador />)}
      {!bouncingLogo && !tapon && confirmation && (<Confirmation />)}
      {!bouncingLogo && notification && <ToolTip notification={notification} />}  
      {tapon && <Tapon {...tapon} />}
      {!bouncingLogo && autoSelection && (<AutoSelection {...autoSelection} />)}
      <style jsx>
        {`
        .bouncingLogo{
            min-height: 100dvh;
            display: flex;
            align-content: center;
            flex-direction: column;
          }
          /* Solo aplicar a pantallas de tamaÃ±o mÃ³vil */
          @media (max-width: 768px) {
            /* Evitar zoom en pantallas mÃ¡s pequeÃ±as (mÃ³viles) */
            meta[name="viewport"] {
              content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
            }
          }
        `}
      </style>
    </>
  )
};

export default FullConfig;
